<script>
export default {
  name: 'SidebarLinkGroup',
  props: {
    title: String
  }
};
</script>

<template>
  <div class="sidebar-link-group">
    <h3 v-if="title" class="sidebar-link-group-title">
      {{ title }}
    </h3>
    <slot />
  </div>
</template>

<style lang="scss" scoped>
@import '@/styles/variables.scss';

.sidebar-link-group {
  margin-bottom: 1.5rem;

  .sidebar-link-group-title {
    font-size: 0.75rem;
    color: $--color-gray-60;
    text-transform: uppercase;
    padding: 0 1.25rem;
    margin-bottom: 0.5rem;
  }
}
</style>
